import { signalStore, withState } from '@ngrx/signals';
import { initialHolidayState } from './holiday.state';
import { withHolidayApiMethods } from './holiday.methods.api';

export const HolidayStore = signalStore(
  { providedIn: 'root' },
  withState(initialHolidayState),
  withHolidayApiMethods
);
